import { Component, OnInit } from '@angular/core';
import { IM4EntryService } from 'src/app/services/transit/im4-entry.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-vehicles-pending-im4-entry',
  templateUrl: './vehicles-pending-im4-entry.component.html',
  styleUrls: ['./vehicles-pending-im4-entry.component.css']
})
export class VehiclesPendingIM4EntryComponent implements OnInit{
  page: number = 1;
  count: number = 0;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  warningMessage: string | null = null;
  vehicles: any[] = [];
  searchText: string = '';
  isProcessing: boolean = false;
  rowCount: number=0;
  etaFilter!: FormGroup;
  startDate:any='';
  endDate:any='';
  submitted: boolean = false;

  constructor(
    private im4EntryService: IM4EntryService,
    private formBuilder: FormBuilder,
  ){
    this.etaFilter = this.formBuilder.group({
      eta_from: ['', Validators.required],
      eta_to: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.getVehiclesPendingEntry();
  }

  getVehiclesPendingEntry(): void {
    this.im4EntryService.getVehiclesPendingEntry()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.vehicles = response.data;
          this.rowCount = this.vehicles.length;
        }else if(response.status==='no_data'){
          this.rowCount =0;
          this.errorMessage=response.message;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
        }
      },
      error: (error) => {
        this.errorMessage=error;
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
    this.getVehiclesPendingEntry();
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
  }

  filter(startDate:any,endDate:any):void {
    this.im4EntryService.filterVehiclesPendingEntry(startDate,endDate)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.vehicles = response.data;
          this.rowCount = this.vehicles.length;
          this.isProcessing=false;
          this.warningMessage=null;
          this.errorMessage=null;
        }else if(response.status==='no_data'){
          this.rowCount =0;
          this.vehicles=[];
          this.warningMessage=response.message;
          this.isProcessing=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isProcessing=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isProcessing=false;
      }
    });
  }

  handleSubmit(){
    this.submitted=true;

    if(this.etaFilter.valid) {
      this.isProcessing=true
      this.startDate=this.etaFilter.value.eta_from;
      this.endDate=this.etaFilter.value.eta_to;

      this.filter(this.startDate,this.endDate);
    }
  }
}
